/**
 * @file 单个号码手机预览图
 * @author
 */

import React from 'react';
import phoneCall from '../../asset/img/userCenter/d20_telephone_outlined.png';
import dianhua from '../../asset/img/userCenter/dianhua1.jpeg';

import iconCustomer from '../../asset/img/userCenter/customer.png';

export default function SinglePhonePreview(props: any) {
    const {iconSrc, name, phones} = props;
    return (
        <div className="singlePhonePreview">
            <div className="transform-phone">
                <div className="top-banner">
                    <p>{name?.length ? <span>{name}电话</span> : <span>企业对外展示名称</span>}</p>
                </div>
                <div className="single-card">
                    <div className="main-content">
                        <div className="c-span2 content-logo">
                            <img src={iconSrc || iconCustomer} alt="" width="100%" />
                        </div>
                        <div className="content-right">
                            <div className="phone-msg c-span10">
                                <div className="phone-num">
                                    {phones[0]?.value}
                                    {phones[0]?.extensionP?.length ? `转${phones[0].extensionP}` : ''}
                                    <div className="phone-label">百度安全认证</div>
                                </div>
                                {phones[0]?.telName?.length ? (
                                    <div className="title-msg">{phones[0]?.telName}</div>
                                ) : (
                                    <div className="title-msg">认证号码标签</div>
                                )}
                            </div>
                            <div className="phone-icon c-span2">
                                <img src={phoneCall} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="slink-list">
                        <div className="slink-item">号码报错</div>
                        <div className="slink-item">认证我的企业</div>
                    </div>
                    <div className="card-source">
                        <img
                            src={dianhua}
                            alt=""
                        />
                        <span>百度安全号码认证平台</span>
                        <span className="right-back">...</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
